import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DxDataGridModule, DxTextAreaModule, DxPopupModule} from 'devextreme-angular';
import {ContainerComponent} from 'src/app/components/container/container.component';
import {DevEpressCommonModule} from 'src/app/dev-epress-common.module';
import {MenuItemsByRoleRoutingModule} from 'src/app/pages/settings/menu-items-by-role/menu-items-by-role-routing.module';
import {DashboardAccessControlComponent} from './dashboard-access-control.component';

@NgModule({
	declarations: [
		DashboardAccessControlComponent,
	],
	exports: [
		DashboardAccessControlComponent,
	],
	imports: [
		CommonModule,
		MenuItemsByRoleRoutingModule,
		DxDataGridModule,
		DevEpressCommonModule,
		DxTextAreaModule,
		DxPopupModule,
		ContainerComponent,
	],
})
export class DashboardAccessControlModule { }